import React from "react";
import ReactiveButton from "reactive-button";
import About from "../components/About";
import AwardsSection from "../components/AwardsSection";
import Work from "../components/Work";
import {
  AiOutlineGithub,
  AiOutlineInstagram,
  AiOutlineLinkedin,
} from "react-icons/ai";
import { isMobile } from "../common";
import MobileAbout from "../components/MobileAbout";

function HomePage() {
  return (
    <div className="homepage-shell">
      <p className="indicator">
        <span>Scroll</span>
        <span>↓</span>
      </p>

      <div className="navbar-floating">
        <div className="nav-group">
          <div className="nav-btn">
            <ReactiveButton
              onClick={() => {
                window.scrollTo({
                  top: window.innerHeight * (isMobile() ?1:0.9),
                  left: 0,
                  behavior: "smooth",
                });
              }}
              outline
              key={2}
              style={{ border: "none", color: "#fff" }}
              rounded
              color="light"
              idleText="ABOUT"
            />
          </div>
          <div className="nav-btn">
            <ReactiveButton
              onClick={() => {
                window.scrollTo({
                  top: window.innerHeight * (isMobile() ?4.8:3.15),
                  left: 0,
                  behavior: "smooth",
                });
              }}
              outline
              key={1}
              style={{ border: "none", color: "#fff" }}
              rounded
              color="light"
              idleText="WORK"
            />
          </div>
          <div className="nav-btn">
            <ReactiveButton
              onClick={() => {
                window.open("/siddaiah_resume.pdf", "_blank");
              }}
              outline
              key={3}
              style={{ border: "none", color: "#fff" }}
              rounded
              color="light"
              idleText="RESUME"
            />
          </div>
        </div>
      </div>

      {isMobile() ? <MobileAbout /> : <About />}
      <AwardsSection />

      <div className="portfolio-footer">
        <Work />
        <div className="footer-row">
          <div>by Siddaiah M — 2026</div>
          <div className="footer-links">
            <a href="https://www.instagram.com/_the_fascinating_mortal_/" rel="noreferrer" target="_blank">
              <AiOutlineInstagram className="footer-icon" />
            </a>
            <a href="https://www.linkedin.com/in/siddaiahm/" rel="noreferrer" target="_blank">
              <AiOutlineLinkedin className="footer-icon" />
            </a>
            <a href="https://github.com/siddaiahm" rel="noreferrer" target="_blank">
              <AiOutlineGithub className="footer-icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
